import React, { useEffect, useState, useRef } from "react";

// Custom cursor: 8px dot expands to labeled ring over interactive elements.
export default function Cursor() {
  const [enabled, setEnabled] = useState(false);
  const [hover, setHover] = useState(false);
  const [label, setLabel] = useState("");
  const ref = useRef(null);
  const raf = useRef(0);
  const pos = useRef({ x: -100, y: -100 });
  const target = useRef({ x: -100, y: -100 });

  useEffect(() => {
    // Only on fine-pointer devices
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    setEnabled(true);

    const onMove = (e) => {
      target.current = { x: e.clientX, y: e.clientY };
      const el = e.target;
      if (!(el instanceof Element)) return;
      const interactive = el.closest("a, button, [role='button'], input, textarea, select, [data-cursor-label]");
      if (interactive) {
        setHover(true);
        setLabel(interactive.getAttribute("data-cursor-label") || "");
      } else {
        setHover(false);
        setLabel("");
      }
    };
    const tick = () => {
      pos.current.x += (target.current.x - pos.current.x) * 0.22;
      pos.current.y += (target.current.y - pos.current.y) * 0.22;
      if (ref.current) {
        ref.current.style.transform = `translate3d(${pos.current.x}px, ${pos.current.y}px, 0) translate(-50%, -50%)`;
      }
      raf.current = requestAnimationFrame(tick);
    };
    window.addEventListener("mousemove", onMove);
    raf.current = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf.current);
    };
  }, []);

  if (!enabled) return null;

  const classes = ["az-cursor"];
  if (hover) classes.push("az-cursor--hover");
  if (label) classes.push("az-cursor--label");

  return (
    <div ref={ref} className={classes.join(" ")} aria-hidden="true">
      <div className="w-full h-full flex items-center justify-center">
        <span className="az-cursor__label">{label}</span>
      </div>
    </div>
  );
}
